import styled from "styled-components";

export const DisclaimerBox = styled.div`
  margin-top: 120px;
  margin-right: 30px;
  font-size: 10px;
  text-align: right;
  color: white;
  background-color: transparent;
  @media only screen and (min-width: 2498px) {
    margin-top: 15px;
    margin-right: 140px;
  }
  @media only screen and (max-width: 1600px) {
    margin-top: 10px;
  }
  @media only screen and (max-width: 1536px) {
    margin-top: 1px;
  }
  @media only screen and (max-width: 1440px) {
    margin-top: 20px;
  }
  @media only screen and (max-width: 1366px) {
    margin-top: -29px;
  }
  @media only screen and (max-width: 1280px) {
    margin-top: -49px;
  }
  @media only screen and (max-width: 1280px) {
    margin-top: -49px;
    margin-right: -30px;
  }
  @media only screen and (max-width: 1024px) {
    margin-top: -25px;
  }
  @media only screen and (max-width: 414px) {
    margin-right: -80px;
    margin-top: 45px;
  }
  @media only screen and (max-width: 375px) {
    margin-top: -44px;
  }
  @media only screen and (max-width: 360px) {
    margin-top: -33px;
  }
`;
